<script lang="ts">
import { classname } from '@/js/utils';
import BaseInputSwitch from '@/js/vue/base/base-switch.vue';

const classAdditionalService = classname('additional-service');
export default {
  name: 'AppAdditionalService',
  components: {
    BaseInputSwitch,
  },
  methods: {
    classAdditionalService,
  },
};
</script>

<template>
  <BaseInputSwitch>
    <span :class="classAdditionalService()">
      <span :class="classAdditionalService('icon-wrapper')">
        <slot name="icon" />
      </span>
      <span :class="classAdditionalService('text')">
        <span :class="classAdditionalService('title-wrapper')">
          <span :class="classAdditionalService('title')"><slot name="title" /></span>
          <span :class="classAdditionalService('subtitle')"><slot name="subtitle" /></span>
        </span>
        <span :class="classAdditionalService('desc')"><slot name="desc" /></span>
      </span>
    </span>
  </BaseInputSwitch>
</template>

<style lang="scss">
.additional-service {
  display: flex;
  grid-gap: 44px;
  align-items: center;

  &__icon-wrapper {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }

  &__text {
    display: grid;
    grid-gap: 10px;
    flex-grow: 1;
    color: #000000;
    line-height: 1;
  }

  &__title-wrapper {
    display: flex;
    grid-gap: 8px;
  }

  &__title {
    font-size: 14px;
  }

  &__subtitle {
    font-weight: 300;
    font-size: 12px;
    color: #7c7c7c;
  }

  &__desc {
    font-weight: 300;
    font-size: 12px;
  }

  @media screen and (max-width: 500px) {
    grid-gap: 30px;

    &__icon-wrapper {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      margin-right: 0;
    }
  }
}
</style>
